import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";

import { LoaderCell } from "~/shared/components/trax-grid/loader-cell/loader-cell.tsx";

import { useLoadCellContext } from "../../utils/load-cell-context.tsx";
import { buildLocationCell } from "./location-cell.tsx";

// `buildLocationCell` is invoked once at module scope so the inner
// component reference is stable. The outer wrappers below read
// `isLoading` from `LoadCellContext`, which keeps the function reference
// passed to Kendo's `cells.data` identical across renders (preserving the
// column-reorder / pref-change perf wins from this branch). Passing
// `isLoading: false` to the factory is intentional — the loader path is
// handled in the wrapper before delegating to the inner cell.
const PickupLocationInnerCell = buildLocationCell({
	isLoading: false,
	kind: "pickup",
});
const DeliveryLocationInnerCell = buildLocationCell({
	isLoading: false,
	kind: "delivery",
});

export const PickupLocationCell = (props: GridCustomCellProps) => {
	const { isLoading } = useLoadCellContext();
	return isLoading ? (
		<LoaderCell {...props} />
	) : (
		<PickupLocationInnerCell {...props} />
	);
};

export const DeliveryLocationCell = (props: GridCustomCellProps) => {
	const { isLoading } = useLoadCellContext();
	return isLoading ? (
		<LoaderCell {...props} />
	) : (
		<DeliveryLocationInnerCell {...props} />
	);
};
